/**
 * type theo response API get session http://192.168.1.16:8888/swagger-ui.html#/session-api/getByIDUsingGET
 */
export type SessionDTO = Partial<{
	anonymized: boolean;
	expiredTime: string;
	id: string;
	requiresShareKey: boolean;
	shareKey: string;
	shared: boolean;
	storeAuth: string;
	storeUrl: string;
	studies: string[];
	user: string;
}>;

/**
 * type dùng cho SessionAuthenticationProvider
 */
export type SessionWithKey = SessionDTO & {
	sessionKey?: string;
};

export type SessionInfomationActionType = 'UPDATE_SESSION' | 'RESET';
